



























































import { useContext } from '@nuxtjs/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import AppImage from '~/components/partials/App/AppImage.vue';
import CollegeLessonCard from '~/components/partials/College/CollegeLessonCard.vue';
import { THUMBNAIL_250 } from '~/constants/profilesForImage';
import { url } from '~/utils';
import { CollegeLessonType } from '~/enums';

export default defineComponent({
  components: {
    AppImage,
    CollegeLessonCard,
  },
  props: {
    lesson: {
      type: Object,
      required: true,
    },
    status: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { i18n } = useContext();
    const statusInfo = computed(() => {
      switch (props.status) {
        case 'IN_PROGRESS':
          return {
            text: i18n.t('College-01.status.working').toString(),
            bgColor: 'bg-Black88',
          };
        case 'COMPLETED':
          return {
            text: i18n.t('College-01.status.done').toString(),
            bgColor: 'bg-status-gray',
          };
        default:
          return {
            text: i18n.t('College-01.status.waiting').toString(),
            bgColor: 'bg-Black88',
          };
      }
    });
    const link = computed(() => {
      switch (props.lesson.lesson_type) {
        case CollegeLessonType.BASIC:
          return url('COLLEGE_BASIC_DETAIL', { id: props.lesson.id });
        case CollegeLessonType.AREA:
          return url('COLLEGE_PRODUCING_AREA_DETAIL', { id: props.lesson.id });
        default:
          return '';
      }
    });
    return {
      url,
      statusInfo,
      link,
      CollegeLessonType,
      THUMBNAIL_250,
    };
  },
});
